import Icon from '../components/Icon.vue'

Icon.register({
  'poo-storm': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M308 336H250.3L267.6 271.1C269.6 263.5 263.9 256 256 256H188C182 256 176.9 260.5 176.1 266.4L160.1 386.4C159.1 393.6 164.7 400 172 400H231.3L208.3 497.2C206.5 504.8 212.3 512 220 512 224.2 512 228.2 509.8 230.4 506L318.4 354C323 346 317.2 336 308 336zM374.4 224.7C380.3 215.1 384 204.1 384 192 384 156.7 355.3 128 320 128H314.1C317.7 117.9 320 107.3 320 96 320 43 277 0 224 0 218.8 0 213.8 0.7 208.9 1.5 218.3 14.6 224 30.6 224 48 224 92.2 188.2 128 144 128H128C92.7 128 64 156.7 64 192 64 204.1 67.7 215.1 73.6 224.7 32.6 228 0 262.2 0 304 0 348 36 384 80 384H128.3C128.4 383.4 128.3 382.8 128.3 382.2L144.3 262.2C147.3 240.4 166 224 188 224H256C269.8 224 282.5 230.3 290.9 241.2S302.1 266 298.5 279.3L291.9 304H307.9C323.6 304 338.2 312.4 346 326 353.8 339.6 353.8 356.5 346 370L337.9 384H367.9C411.9 384 447.9 348 447.9 304 448 262.2 415.4 228 374.4 224.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/poo-storm.js
// module id = dPWa
// module chunks = 144